/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  CopyDocumentsVolumes200,
  CopyDocumentsVolumesBody,
  CreateProjectBody,
  Folder,
  ForbiddenResponse,
  InternalServerErrorResponse,
  ListProjects200,
  ListProjectsParams,
  NotFoundResponse,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * @summary Creates a new project
 */
export const createProject = (
    organizationId: string,
    createProjectBody: CreateProjectBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Folder>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: createProjectBody
    },
      options);
    }
  


export const getCreateProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{organizationId: string;data: CreateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{organizationId: string;data: CreateProjectBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {organizationId: string;data: CreateProjectBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createProject(organizationId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = CreateProjectBody
    export type CreateProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Creates a new project
 */
export const useCreateProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{organizationId: string;data: CreateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCreateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Returns the list of projects in the current organization
 */
export const listProjects = (
    organizationId: string,
    params?: ListProjectsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ListProjects200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects`, method: 'get',
        params, signal
    },
      options);
    }
  

export const getListProjectsQueryKey = (organizationId: string,
    params?: ListProjectsParams,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects`, ...(params ? [params]: [])] as const;
    }

    
export const getListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProjectsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Returns the list of projects in the current organization
 */
export const useListProjects = <TData = Awaited<ReturnType<typeof listProjects>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: ListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListProjectsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Gets all volumes for a project
 */
export const getVolumes = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Folder[]>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/volumes`, method: 'get', signal
    },
      options);
    }
  

export const getGetVolumesQueryKey = (organizationId: string,
    projectId: string,) => {
    
    return [`https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/volumes`] as const;
    }

    
export const getGetVolumesQueryOptions = <TData = Awaited<ReturnType<typeof getVolumes>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVolumesQueryKey(organizationId,projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVolumes>>> = ({ signal }) => getVolumes(organizationId,projectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVolumesQueryResult = NonNullable<Awaited<ReturnType<typeof getVolumes>>>
export type GetVolumesQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Gets all volumes for a project
 */
export const useGetVolumes = <TData = Awaited<ReturnType<typeof getVolumes>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVolumes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVolumesQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * Copies selected documents from a source volume (projectId) to a target volume (volumeId)
 * @summary Copies documents from one volume to another
 */
export const copyDocumentsVolumes = (
    organizationId: string,
    projectId: string,
    volumeId: string,
    copyDocumentsVolumesBody: CopyDocumentsVolumesBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CopyDocumentsVolumes200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/projects/${projectId}/volumes/${volumeId}/documents`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: copyDocumentsVolumesBody
    },
      options);
    }
  


export const getCopyDocumentsVolumesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyDocumentsVolumes>>, TError,{organizationId: string;projectId: string;volumeId: string;data: CopyDocumentsVolumesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof copyDocumentsVolumes>>, TError,{organizationId: string;projectId: string;volumeId: string;data: CopyDocumentsVolumesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyDocumentsVolumes>>, {organizationId: string;projectId: string;volumeId: string;data: CopyDocumentsVolumesBody}> = (props) => {
          const {organizationId,projectId,volumeId,data} = props ?? {};

          return  copyDocumentsVolumes(organizationId,projectId,volumeId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CopyDocumentsVolumesMutationResult = NonNullable<Awaited<ReturnType<typeof copyDocumentsVolumes>>>
    export type CopyDocumentsVolumesMutationBody = CopyDocumentsVolumesBody
    export type CopyDocumentsVolumesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Copies documents from one volume to another
 */
export const useCopyDocumentsVolumes = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyDocumentsVolumes>>, TError,{organizationId: string;projectId: string;volumeId: string;data: CopyDocumentsVolumesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCopyDocumentsVolumesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    